
export default {
    namespaced: true,
    pages: {
      title: "página web | páginas web",
      description: "descripción",
      url: "URL",
      facilities: "Instalaciones",
      shared: "compartido",
    },
  }
